import { Product } from "../../../gobalType";

export type PlantNameRow = { name: string; product: Product };

export function buildSortedUniquePlantRows(plants: Product[]): PlantNameRow[] {
  const byName = new Map<string, Product>();
  plants.forEach((p) => {
    const n = p?.name?.trim();
    if (n && !byName.has(n)) byName.set(n, p);
  });
  return Array.from(byName.entries())
    .sort((a, b) =>
      a[0].localeCompare(b[0], undefined, { sensitivity: "base" })
    )
    .map(([name, product]) => ({ name, product }));
}
